module.exports = __webpack_public_path__ + "static/img/so1_5.26525c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so1_5.jpg
// module id = yT4j
// module chunks = 11